function contentHighlightCarousel() {
    document.querySelectorAll('.feature-card__slider').forEach(carousel => new Splide(carousel, {
        perPage: 3,
        pagination: false,
        gap: '1.25rem',
        padding: {
            left: 0,
            right: '1.25rem'
        },
        breakpoints: {
            992: {
                perPage: 2,
            },
            600: {
                perPage: 1,
            },
        }
    }).mount());
}

// function contentHighlightCarousel() {
//     new Splide('.feature-card__slider', {
//         perPage: 3,
//         pagination: false,
//         gap: '1.25rem',
//         padding: {
//             left: 0,
//             right: '1.25rem'
//         },
//         breakpoints: {
//             992: {
//                 perPage: 2,
//             },
//             600: {
//                 perPage: 1,
//             },
//         }
//     }).mount();
// }